module.exports = __webpack_public_path__ + "img/shalong.17dfe724.png";